import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import Coupon from "../components/Coupon";
import Nodata from "../components/NoData";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";


export default function CouponUsed() {
    const { t } = useTranslation();
    
    const [useCnt, setUseCnt] = useState(0);
    const [useExpiredCnt, setUseExpiredCnt] = useState(0);
    

    const [data, setData] = useState({});
    const [request] = useAxios();

    const fetchData = async () => {
        
        const response = await request.post("/app/mypage/getMyCouponIssuHistListAPI", {

        });
        if(response.data.resultCode === 200){           
            setData(response.data.result);
            setUseCnt(response.data.result.couponIssuHistList.filter((coupon) => coupon.couponUseAt === 'N' && coupon.endAt === 'N'  ).length)
            setUseExpiredCnt(response.data.result.couponIssuHistList.filter((coupon) => coupon.couponUseAt === 'Y' || coupon.endAt === 'Y'  ).length)
            
            
        }            
    };


    

    useEffect(() => {
        fetchData();
     
      }, []);

    return(
        <div>
            <div className="backGround bgBlue"></div>
            {data.couponIssuHistList?(
            <>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={t(`Message.my_coupon_list_title`)}/>
                <div className="tabArea">
                    <Link to="/CouponAvail" className="tabBtn">{t(`Message.my_coupon_list_tab1`, {couponUseTargetList: useCnt})}</Link>
                    <Link to="" className="tabBtn active">{t('Message.my_coupon_list_tab2' , {couponUseExpiredList: useExpiredCnt})}</Link>
                </div>
            </div>

            <div className="hdTabContWr">
                {data.couponIssuHistList && data.couponIssuHistList.filter((coupon) => coupon.couponUseAt === 'Y' || coupon.endAt === 'Y'  ).length === 0?(
                <div className="floatCenter">
                    <Nodata text={t(`Message.my_coupon_list_empty_coupon_use_exp`)}/>
                </div> 
                ):null}

                {/*
                <div className="dfcsG8">
                    <input type="text" name="" id="" placeholder={t(`Message.coupon_avail_enter_coupon_code`)} className="bde"/>
                    <button type="button" className="btn40 greenB cFFF wd100"> {t(`Message.coupon_avail_regist_coupon`)} </button>
                </div>
                */}

                <div className="couponList">
                    {data.couponIssuHistList &&  data.couponIssuHistList.filter((coupon) => coupon.couponUseAt === 'Y' || coupon.endAt === 'Y'  ).map((obj, index) => (
                         <Coupon  key={index}
                         type={obj.couponUseAt === 'Y'?"used":"overDate"} 
                         discount={obj.couponValue + obj.couponValueUnitCodeNm+' ' + t(`Message.common_msg_discount`)}
                         name={obj.couponSj}                        
                         date={"~ "+obj.useEndDe+ (obj.couponUseAt === 'N' && obj.endAt === 'Y')?"(" + t(`Message.coupon_used_expiration`) + ")":""}                      
                         obj = {obj}
                         />
                    ))}                         
                </div>
            </div>
            </>
             ):null}
        </div>
    );
};